export default __webpack_public_path__ + "c71c53e40c7c86805ba15caefa2950fa.jpg";